import { Typography, type TypographyProps } from '@mui/material';
import { palette } from '../theme/palette';

export function EyebrowText({ sx, children, ...rest }: TypographyProps) {
  return (
    <Typography
      variant="overline"
      sx={{
        color: palette.text.muted,
        fontSize: '0.7rem',
        letterSpacing: '0.12em',
        display: 'block',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Typography>
  );
}
